<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b] ">Option Modification</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Option Modification / Department</p>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="flex items-center gap-5">
            <h1 class="text-[#24723b] font-semibold text-lg">Search/Edit Department Portal</h1>
            <button v-on:click="HideView" class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add Deparment</button>
        </div>
        <!-- <input class="p-3 mt-3" type="text" placeholder="Search"> -->
        <div class="papsi-container h-[300px]overflow-auto mt-3">
            <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl  :Action="true" :header="header" :column="column" :info="info" :EButton="true" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton"/>
            </div>
        </div>
    </div>
    <div v-if="AddDepartment">
        <div @click="AddDepartment = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
             <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
                <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#016B00] relative">
                <div class="pafcpic_header bg-[#016B00] py-3 px-6">
                    <p class="text-[#ffffff] text-md  font-semibold">{{ type }}</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Office/Division</p>
                    <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none  overflow-y-auto focus:h-auto" v-model="divisionData">
                        <option selected disabled value="">Select Office/Division</option>
                        <option v-for="(division, index) in $store.state.divisionList" :key="index" :value="division.division_code">{{ division.division_description }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">{{ departmentLabel }}</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" placeholder="Input Department" @input="department = department.toUpperCase()" v-model="department">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">{{ departmentLabelAbbr }}</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" placeholder="Input Department Abbreviation" @input="abbreviation = abbreviation.toUpperCase()"  v-model="abbreviation">
                      <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Branch</p>
                    <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none  overflow-y-auto focus:h-auto" v-model="branch_key" @change="filterRcCode">
                        <option selected disabled value="">Select Branch</option>
                        <option v-for="(branch, index) in $store.state.branch" :key="index" :value="branch.br_code">{{ branch.br_desc }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Responsibility Center Code</p>
                    <select :disabled="rc_select"  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none  overflow-y-auto focus:h-auto" v-model="rc_code">
                        <option selected disabled value="">Select RC Code</option>
                        <option v-for="(branch, index) in rc_list" :key="index" :value="branch.rc_code.trim()">{{ branch.br_name.trim() }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Status</p>
                    <select class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none  overflow-y-auto focus:h-auto" v-model="status">
                        <option value="1">ACTIVE</option>
                        <option value="0">INACTIVE</option>
                    </select>
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-white bg-[#016B00] py-1.5 px-7     rounded-md w-[100px] text-center"     v-if="Active === 'Add'" v-on:click="clickAddDepartment">Add</button>
                <button class="text-sm text-white bg-[#016B00] py-1.5 px-7     rounded-md w-[100px] text-center"     v-if="Active === 'Update'" v-on:click="clickEditDepartment">Update</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px] text-center"     v-on:click="AddDepartment = false">Cancel</button>
            </div>
        </div>
        </div>
    </div>
    
    <PromptComponent v-if="prompt" :header="promptheader" :header1="promptheader1" :success="success" @close="prompt = false"/>

</template>

<script>
import TableControl from "../controls/TableControl/TableControl.vue"

import Dep from "@/services/department";
import PromptComponent from "@/componentsv1/Prompt/PromptComponent.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components:{
        TableControl,
        PromptComponent
    },
    data(){
        return{
            status: '1',
            prompt: false,
            promptheader: null,
            promptheader1: null,
            success:false,
            rc_list : '',
            rc_select: '',
            rc_code: '',
            branch_key: '',
            departmentLabel:null,
            departmentLabelAbbr:null,
            type:"",
            Update: false,
            SuccessAddDepartment: false,
            Validation:    false,
            info:           null,
            AddDepartment: false,
            TableView:      true, 
            division:         '',
            divisionData:     '',
            Active:           '',
            department:       '',
            abbreviation:     '',
            EditID:           '',
            header:[
                {title:'Department No.'},
                {title:'Department'},
                {title:'Abbreviation'},
                {title:'Action'},
            ],
            column:[
                'department_code',
                'department',
                'abbreviation'
            ],
        }
    },
    mounted(){
        this.getDepartment()
    }
    ,
    methods:{
        EditButton(row){
            this.type                   =    "UPDATE DEPARTMENT"
            this.departmentLabel        =    "Update Department"
            this.departmentLabelAbbr    =    "Enter Updated Department Abbreviation"
            this.Active                 =     'Update'
            this.divisionData           =     row.division_code
            this.department             =     row.department
            this.abbreviation           =     row.abbreviation
            this.EditID                 =     row.department_code
            this.AddDepartment          =      true
            this.status                 =      row.status 

            if(row.rc_code != null)
            {
                const data = this.$store.state.rc_branch.find(branch => branch.rc_code.trim() === row.rc_code.trim())
                this.branch_key = data.br_code.trim()
                this.filterRcCode()
                this.rc_code = row.rc_code.trim()
            }
            else{
                this.rc_select  = true
                this.branch_key = ''
                this.rc_code    = ''
            }
        },
        HideView(){
            this.type =     "ADD DEPARTMENT"
            this.departmentLabel        =    "Create New Department"
            this.departmentLabelAbbr    =    "Create Department Abbreviation"
    
            if (!this.TableView){
                this.TableView     =   true
                this.AddDepartment =  false
            }
            else{
                this.Active        =  'Add'
                this.divisionData  =   ''
                this.department    =   ''
                this.abbreviation  =   ''
                this.status = '1'
                this.AddDepartment =   true
            }
        },
        filterRcCode(){
           this.rc_code = ''
           this.rc_select = false
           this.rc_list = this.$store.state.rc_branch.filter(branch => branch.br_code.trim() === this.branch_key)
        },
        async clickAddDepartment(){
            let that = this
            this.$emit("showLoader")
            await Dep.addDepartment(that.divisionData, that.department, that.abbreviation, that.rc_code, that.status).then(async function(){
                await that.getDepartment()
                that.AddDepartment   = false
                that.success         = true
                that.promptheader    = "Successsfully Added New Department"
                that.promptheader1   = "To modify the Department, go to the Option Modification Module."
                that.prompt          =  true
            }).catch(function(error){
                that.success       =  false
                that.promptheader  = "Error"
                that.promptheader1 =  error.response.data.message
                that.prompt        =  true
            });
            this.$emit("hideLoader")
        },
        async clickEditDepartment(){
            let that = this
            this.$emit("showLoader")
            await Dep.editDepartment(that.divisionData, that.EditID, that.department, that.abbreviation, that.rc_code, that.status).then(async function(){
                await that.getDepartment()
                that.AddDepartment   = false
                that.success         = true
                that.promptheader    = "Successsfully Modify Department"
                that.promptheader1   = "To modify the Department, go to the Option Modification Module."
                that.prompt          =  true
            }).catch(function(error){
                that.success       =  false
                that.promptheader  = "Error"
                that.promptheader1 =  error.response.data.message
                that.prompt        =  true
            });
            this.$emit("hideLoader")
        },
        async getDepartment(){
            this.$emit("showLoader")
            let that = this
            await Dep.getDepartment().then(function(response){
                that.$store.state.departmentList = response.data.data
                that.info          =  response.data.data
            }).catch(function(error){
                console.log(error)
            });
            this.$emit("hideLoader")
        },
    }
    

})

</script>

